import {type Section} from '@/shared/components/legalDocuments/sectionView';

export const GUIDELINES: Section[] = [
  {
    title: 'Respect Boundaries',
    items: [
      {
        type: 'text',
        content:
          'Everyone has different comfort levels, so please respect them. Avoid sharing nudity, explicit content, or sexual desires on your public profile. This includes your profile photos, bio text, audio prompt, and prompts - sexual innuendo, suggestive language, and thinly veiled sexual offers in your written bio or voice recording are treated the same as explicit images and are not allowed. Boundaries matter in conversation too, not just on your profile - see "No Unsolicited Sexual Content in Chat" below.',
      },
    ],
  },
  {
    title: 'No Unsolicited Sexual Content in Chat',
    items: [
      {
        type: 'text',
        content:
          'Sending nudes, sexual images, or explicit videos to someone who has not asked for or agreed to receive them is not allowed, even in private messages. Persistently steering a conversation toward sexual topics after the other person has changed the subject, gone quiet, or asked you to stop is also not allowed - consent to flirt or chat does not mean consent to sexual content or sexual pressure. If someone sends you unwanted sexual content or won’t drop an unwanted sexual topic, report and block them; we treat this as a form of sexual harassment (see “Communicate with Respect” below).',
      },
    ],
  },
  {
    title: 'Protect Personal Information',
    items: [
      {
        type: 'text',
        content:
          'Share your personal information thoughtfully. Do not publicly display sensitive details like phone numbers or social media handles. Also, be wary of sharing or requesting financial information. This applies to other people’s information too - do not post, forward, or threaten to expose anyone else’s phone number, address, workplace, financial details, immigration status, health information, or other sensitive personal data without their consent (“doxxing”). Do not pressure, guilt, or repeatedly ask someone to give you their phone number or move the conversation to WhatsApp, Instagram, Telegram, Snapchat, or any other outside app before they’re ready. If someone pushes you to leave the app quickly, be cautious - insisting on moving off-platform early is one of the most common tactics used in romance scams and harassment, and we treat repeated, unwanted requests to do so as a guideline violation.',
      },
    ],
  },
  {
    title: 'Avoid Violence',
    items: [
      {
        type: 'text',
        content:
          'We promote positivity and do not tolerate any violent content, including depictions of harm or the use of weapons. If a situation suggests imminent danger, we will intervene with appropriate crisis resources. This covers threats of violence or self-harm, glorification of violence, and content depicting cruelty to animals, in addition to graphic imagery.',
      },
    ],
  },
  {
    title: 'Personal, Not Business',
    items: [
      {
        type: 'text',
        content:
          'Bumpy is for personal connections, not commercial activities. Please do not use Bumpy for advertising, promoting businesses, or seeking financial support. This includes promoting other platforms or similar subscription content, multi-level-marketing pitches, sugar dating or pay-for-companionship arrangements, cryptocurrency or investment pitches, and asking other users for loans, gifts, or “help” with an emergency.',
      },
    ],
  },
  {
    title: 'Authenticity is Key',
    items: [
      {
        type: 'text',
        content:
          "Be genuine and avoid creating fake profiles or impersonating others. Authentic interactions form the best connections. Use your own recent photos, keep one account per person, and don't use another person's name, images, or identity - including celebrities or people you don't know - even as a joke. Register only with an email address and phone number that belong to you; creating an account with someone else's contact details is impersonation and the account will be removed. AI-generated or heavily altered photos presented as real photos of you are also not allowed.",
      },
    ],
  },
  {
    title: 'Communicate with Respect',
    items: [
      {
        type: 'text',
        content:
          'Interacting with people from various backgrounds can be challenging. Maintain respect to ensure conversations remain pleasant and productive. We do not tolerate harassment or any form of bullying. Disrespectful behavior includes, but isn’t limited to: insulting, name-calling, mocking, or demeaning another user; body-shaming or commenting negatively on someone’s appearance; threats or intimidation; sending repeated unwanted messages after someone has stopped responding or asked you to stop; and any form of stalking, doxxing, or sexual harassment (including the unsolicited sexual content described above).',
      },
    ],
  },
  {
    title: 'No Hate',
    items: [
      {
        type: 'text',
        content:
          'Discrimination based on race, ethnicity, gender, or any other identity is strictly prohibited. If someone does not meet your preferences, simply move on without engagement. This includes hate speech, slurs, and content that demeans, excludes, or dehumanizes people on the basis of race, ethnicity, national origin, religion, gender, gender identity, sexual orientation, disability, age, HIV status, body type, or any other characteristic.',
      },
    ],
  },
  {
    title: 'Adult Community',
    items: [
      {
        type: 'text',
        content:
          'Only individuals 18 years or older can use Bumpy. We strictly prohibit images of minors, even if they are photos of yourself from childhood. If we believe an account belongs to someone under 18, we will remove it.',
      },
      {
        type: 'text',
        content:
          'We have a zero-tolerance policy for child sexual abuse and exploitation (“CSAE”). This means we do not allow child sexual abuse material (“CSAM”), grooming, sexual solicitation of a minor, sextortion of a minor, or any other content or behaviour that sexually abuses or exploits a child, anywhere on Bumpy (“Bumpy - International Dating” as listed on Google Play and the Apple App Store) or on Wonder. When we become aware of CSAM, we remove it and report it as required by law, including to the National Center for Missing & Exploited Children (NCMEC) or the relevant local authority, and we cooperate with law enforcement. You can report suspected CSAE at any time using the in-app report button on a profile, photo, or message, or by contacting our designated Child Safety point of contact at legal@bumpy.app.',
      },
    ],
  },
  {
    title: 'Legal Compliance',
    items: [
      {
        type: 'text',
        content:
          'All interactions on Bumpy must comply with the law. Illegal activities, including the sale of banned substances or counterfeit goods, are not allowed. This also covers solicitation of sex work or prostitution where illegal, human trafficking, and any other activity prohibited under the laws of your location.',
      },
    ],
  },
  {
    title: 'Your Space, Your Content',
    items: [
      {
        type: 'text',
        content:
          "Only post content you own or have permission to share. Respect copyrights and privacy. Do not screenshot or forward someone else's profile, photos, voice recordings, or private messages outside the app without their consent.",
      },
    ],
  },
  {
    title: 'Community Integrity',
    items: [
      {
        type: 'text',
        content:
          'Do not spread misinformation, create spam, or manipulate others. Use Bumpy honestly and responsibly. This includes bulk or automated messaging, bots, fake engagement, and using the platform to run scams of any kind - romance scams, phishing links, fake investment or crypto opportunities, and requests for money or gift cards are never allowed, regardless of how the relationship developed.',
      },
    ],
  },
];
